import { Component, OnInit, Input, EventEmitter } from '@angular/core';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';
import { PdfmakeService } from 'ng-pdf-make/pdfmake/pdfmake.service';
import { Cell, Row, Table } from 'ng-pdf-make/objects/table';

import { CatalogsSettingsService, Payroll } from '../../services/catalogs-settings.service';
import { LogService } from '../../services/log.service';
import { EmployeeService } from '../../services/employee.service';
import { JobService } from '../../services/job.service';
import { AssistanceReportService } from '../../services/assistance-report.service';
import { OvertimeService } from '../../services/overtime.service';
import { LoanService } from '../../services/loan.service';
import { PayrollService } from '../../services/payroll.service';
import { AuthService } from '../../services/auth.service';
import { PermissionService } from '../../services/permission.service';
import { ActivityService } from '../../services/activity.service';
import { DepartmentService } from '../../services/department.service';

import { Utils } from '../../util';
import { Router } from '@angular/router';
import { CarrierReportService } from '../../services/carrier-report.service';

@Component({
    selector: 'app-display-payroll-estimate',
    templateUrl: './display-payroll-estimate.component.html',
    styleUrls: ['./display-payroll-estimate.component.css', '../../app.component.css']
})

export class DisplayPayrollEstimateComponent implements OnInit {
    allowed: boolean = false;
    permission: any = {};

    readonly COMPLETE = true;
    readonly INCOMPLETE = false;

    readonly IS_OK = 1;

    pickadateParams = Utils.pickadateParamsNoBlank();

    weekday: number;
    textday: string;
    paymentPeriod: string;

    paymentPerPerson = { local: 0, foreign: 0 };
    cfCommission: number;
    multiplicationFactor: number;

    employeesInfo = [];
    employeesPayrollReceipt = [];
    jobsInfo = [];
    activitiesInfo = [];
    departmentsInfo = [];

    _startDate = '';
    endDate: any;

    errorText = '';

    loadText = 0;
    flagProcess = false;
    processEnd = false;
    assistanceEmployee = [];

    globalActions = new EventEmitter<string|MaterializeAction>();
    globalActionsDates = new EventEmitter<string|MaterializeAction>();
    globalActionsPeriod = new EventEmitter<string|MaterializeAction>();

    datesFolders = [];

    flagPayrollProcess = false;

    modalActions = new EventEmitter<string|MaterializeAction>();
    modalParams = [ {
        dismissible: false,
        complete: function() {
            // console.log('Modal : Close');
        }
    } ];

    gpsSubs: any;
    geSubs: any;
    gjSubs: any;
    gpSubs: any;
    gsrbpSubs: any;
    gareSubs: any;
    garebpSubs: any;
    gobrdSubs: any;
    galSubs: any;
    gpeSubs: any;
    gaSubs: any;
    gdSubs: any;

    // Payroll Section
    dataPayroll: Array<any>;
    rowsPayroll: Array<any> = [];
    columnsPayroll: Array<any> = [
        { title: 'Empleado', className: 'left-align', name: 'employeeName', sort: 'asc' },
        { title: 'Total', className: 'right-align', name: 'totalAmount' },
        { title: 'Día 1', className: 'right-align', name: 'payroll1', sort: false },
        { title: 'Día 2', className: 'right-align', name: 'payroll2', sort: false },
        { title: 'Día 3', className: 'right-align', name: 'payroll3', sort: false },
        { title: 'Día 4', className: 'right-align', name: 'payroll4', sort: false },
        { title: 'Día 5', className: 'right-align', name: 'payroll5', sort: false },
        { title: 'Día 6', className: 'right-align', name: 'payroll6', sort: false },
        { title: 'Día 7', className: 'right-align', name: 'payroll7', sort: false },
        { title: 'Total + Bonus', className: 'right-align', name: 'totalPlusBonus', sort: false },
    ];
    pagePayroll = 1;
    itemsPerPagePayroll = 25;
    maxSizePayroll = 5;
    numPagesPayroll = 1;
    lengthPayroll = 0;
    configPayroll: any = {
        paging: true,
        sorting: { columns: this.columnsPayroll },
        filtering: { filterString: '' }
    };

    // Carrier Section
    dataCarrier: Array<any>;
    rowsCarrier: Array<any> = [];
    columnsCarrier: Array<any> = [
        { title: 'Transportista', name: 'carrierName', sort: 'asc' },
        { title: 'Total Empleados', className: 'center', name: 'totalPersons' },
        { title: 'Total', className: 'right-align', name: 'totalAmount' },
        { title: 'Día 1', className: 'center', name: 'carrier1', sort: false },
        { title: 'Día 2', className: 'center', name: 'carrier2', sort: false },
        { title: 'Día 3', className: 'center', name: 'carrier3', sort: false },
        { title: 'Día 4', className: 'center', name: 'carrier4', sort: false },
        { title: 'Día 5', className: 'center', name: 'carrier5', sort: false },
        { title: 'Día 6', className: 'center', name: 'carrier6', sort: false },
        { title: 'Día 7', className: 'center', name: 'carrier7', sort: false }
    ];
    pageCarrier = 1;
    itemsPerPageCarrier = 25;
    maxSizeCarrier = 5;
    numPagesCarrier = 1;
    lengthCarrier = 0;
    configCarrier: any = {
        paging: true,
        sorting: { columns: this.columnsCarrier },
        filtering: { filterString: '' }
    };

    // CarrierF Section
    dataCarrierF: Array<any>;
    rowsCarrierF: Array<any> = [];
    columnsCarrierF: Array<any> = [
        { title: 'Transportista', name: 'carrierName', sort: 'asc' },
        { title: 'Total Empleados', className: 'center', name: 'totalPersons' },
        { title: 'Total', className: 'right-align', name: 'totalAmount' },
        { title: 'Día 1', className: 'center', name: 'carrier1', sort: false },
        { title: 'Día 2', className: 'center', name: 'carrier2', sort: false },
        { title: 'Día 3', className: 'center', name: 'carrier3', sort: false },
        { title: 'Día 4', className: 'center', name: 'carrier4', sort: false },
        { title: 'Día 5', className: 'center', name: 'carrier5', sort: false },
        { title: 'Día 6', className: 'center', name: 'carrier6', sort: false },
        { title: 'Día 7', className: 'center', name: 'carrier7', sort: false }
    ];
    pageCarrierF = 1;
    itemsPerPageCarrierF = 25;
    maxSizeCarrierF = 5;
    numPagesCarrierF = 1;
    lengthCarrierF = 0;
    configCarrierF: any = {
        paging: true,
        sorting: { columns: this.columnsCarrierF },
        filtering: { filterString: '' }
    };

    // Overtime section
    dataOver: Array<any>;
    rowsOver: Array<any> = [];
    columnsOver: Array<any> = [
        { title: 'Empleado', name: 'employeeName', sort: false },
        { title: 'Total Horas', className: 'center', name: 'totalHours', sort: false },
        { title: 'Total', className: 'right-align', name: 'totalAmount', sort: false },
        { title: 'Día 1', className: 'center', name: 'over1', sort: false },
        { title: 'Día 2', className: 'center', name: 'over2', sort: false },
        { title: 'Día 3', className: 'center', name: 'over3', sort: false },
        { title: 'Día 4', className: 'center', name: 'over4', sort: false },
        { title: 'Día 5', className: 'center', name: 'over5', sort: false },
        { title: 'Día 6', className: 'center', name: 'over6', sort: false },
        { title: 'Día 7', className: 'center', name: 'over7', sort: false }
    ];
    pageOver = 1;
    itemsPerPageOver = 25;
    maxSizeOver = 5;
    numPagesOver = 1;
    lengthOver = 0;
    configOver: any = {
        paging: true
    };

    // Loan section
    dataLoan: Array<any>;
    rowsLoan: Array<any> = [];
    columnsLoan: Array<any> = [
        { title: 'Empleado', name: 'employeeName', sort: false },
        { title: 'Total Pago', className: 'right-align', name: 'totalAmount', sort: false }
    ];
    pageLoan = 1;
    itemsPerPageLoan = 25;
    maxSizeLoan = 5;
    numPagesLoan = 1;
    lengthLoan = 0;
    configLoan: any = {
        paging: true
    };

    // Estimate section
    dataEstimate: Array<any>;
    rowsEstimate: Array<any> = [];
    columnsEstimate: Array<any> = [
        { title: 'Concepto', name: 'conceptName', sort: false },
        { title: 'Monto', className: 'right-align', name: 'totalAmount', sort: false }
    ];
    pageEstimate = 1;
    itemsPerPageEstimate = 25;
    maxSizeEstimate = 5;
    numPagesEstimate = 1;
    lengthEstimate = 0;
    configEstimate: any = {
        paging: false
    };

    // Summary values
    payrollTotal = 0;
    carrierTotal = 0;
    overtimeTotal = 0;
    loanTotal = 0;
    estimateTotal = 0;

    payrollModalActions = new EventEmitter<string|MaterializeAction>();
    payrollModalParams = [ {
        dismissible: false,
        complete: function() {
            // console.log('Modal : Close');
        }
    } ];

    emitReceipts = false;

    userSession: string;

    closedPayroll = false;
    acceptanceUser: string;
    acceptanceDate: any;

    permissions = [];

    settings: Payroll;

    constructor(
        private catalogsSettingsService: CatalogsSettingsService,
        private logService: LogService,
        private employeeService: EmployeeService,
        private jobService: JobService,
        private assistanceReportService: AssistanceReportService,
        private overtimeService: OvertimeService,
        private loanService: LoanService,
        private payrollService: PayrollService,
        private pdfmake: PdfmakeService,
        private activityService: ActivityService,
        private authService: AuthService,
        private permissionService: PermissionService,
        private departmentService: DepartmentService,
        private router: Router,
        private settingsService: CatalogsSettingsService,
        private carrierReportService: CarrierReportService
    ) {
        let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
            permissionsSubs.unsubscribe();
            this.permission = this.permissionService.constructPermissionObject(groups, 'payrollEstimate');
            if(!this.permission || !this.permission.readAction) this.router.navigate(['/']);
            else this.allowed = true;
        });

        this.userSession = this.authService.currentUser;

        this.gpsSubs = this.catalogsSettingsService.getPayrollSettings('1').subscribe(payrollObj => {
            this.gpsSubs.unsubscribe();
            this.settings = payrollObj;

            if (payrollObj.startDay === 'sunday') {
                this.weekday = 0;
                this.textday = 'Domingo';
            } else if (payrollObj.startDay === 'monday') {
                this.weekday = 1;
                this.textday = 'Lunes';
            } else if (payrollObj.startDay === 'tuesday') {
                this.weekday = 2;
                this.textday = 'Martes';
            } else if (payrollObj.startDay === 'wednesday') {
                this.weekday = 3;
                this.textday = 'Miércoles';
            } else if (payrollObj.startDay === 'thursday') {
                this.weekday = 4;
                this.textday = 'Jueves';
            } else if (payrollObj.startDay === 'friday') {
                this.weekday = 5;
                this.textday = 'Viernes';
            } else if (payrollObj.startDay === 'saturday') {
                this.weekday = 6;
                this.textday = 'Sábado';
            }

            let { paymentPerPerson: local=0, paymentPerPersonF: foreign=0, cfCommission=0 } = payrollObj;
            this.paymentPerPerson = {local, foreign};
            this.cfCommission = cfCommission;
            this.multiplicationFactor = payrollObj.multiplicationFactor;
            this.paymentPeriod = payrollObj.paymentPeriod;
        });

        this.geSubs = this.employeeService.getEmployees().subscribe(tempEmployees => {
            this.geSubs.unsubscribe();

            for (const idx in tempEmployees) {
                let employeeDisplayValue = `${tempEmployees[idx].name} ${tempEmployees[idx].lastName} (${tempEmployees[idx].internalKey})`;
                this.employeesInfo[tempEmployees[idx].id$] = {
                    name: employeeDisplayValue,
                    cIsForeign: tempEmployees[idx].transportArrive == 3.5,
                    jobId: tempEmployees[idx].jobId,
                    arrive: tempEmployees[idx].transportArrive
                }
                this.employeesPayrollReceipt[tempEmployees[idx].id$] = {
                    name: tempEmployees[idx].lastName + ' ' + tempEmployees[idx].name,
                    folio: tempEmployees[idx].internalKey,
                    department: tempEmployees[idx].departmentId ? tempEmployees[idx].departmentId : '',
                    appliesBonus: tempEmployees[idx].appliesBonus,
                    payroll: null,
                    carrier: null,
                    carrierF: null,
                    carriedF: null,
                    overtime: null,
                    loan: null
                };
            }
        });

        this.gjSubs = this.jobService.getJobs().subscribe(tempJobs => {
            this.gjSubs.unsubscribe();

            for (const idx in tempJobs) {
                this.jobsInfo[tempJobs[idx].id$] = {
                    baseSalary: tempJobs[idx].baseSalary,
                    extraSalary: tempJobs[idx].extraSalary || 0,
                };
            }
        });

        this.gaSubs = this.activityService.getActivities().subscribe(tempActvities => {
            this.gaSubs.unsubscribe();

            for (const idx in tempActvities) {
                this.activitiesInfo[tempActvities[idx].id] = tempActvities[idx].value;
            }
        });

        this.gdSubs = this.departmentService.getDepartments().subscribe(tempDeparments => {
            this.gdSubs.unsubscribe();
            let ds = [];
            for (const idx in tempDeparments) {
                this.departmentsInfo[tempDeparments[idx].id$] = tempDeparments[idx].name;
                ds.push({value: tempDeparments[idx].id$, name: tempDeparments[idx].name});
            }
            this.departmentSelect = [{value: '', name: 'Todos'}, ...ds];
        });
    }
    departmentSelect: any;
    departmentSelected: string = '';

    ngOnInit() {

    }

    @Input()
    set startDate(_startDate: string) {
        this._startDate = _startDate;

        const weekdaySelected = Utils.convertDatefromISOStringtoObject(this._startDate);

        if (weekdaySelected.getDay() === this.weekday || this.paymentPeriod != 'weekly') {
            const toDate = weekdaySelected;
            toDate.setDate(toDate.getDate() + 6);

            this.endDate = toDate.getFullYear() + '-' +
                           ('0' + (toDate.getMonth() + 1)).slice(-2) + '-' +
                           ('0' + toDate.getDate()).slice(-2);
        } else {
            this.endDate = undefined;
            this.errorText = 'El día de inicio de la nómina son los días ' + this.textday;
        }
    }

    get startDate(): string {
        return this._startDate;
    }

    changeDate() {
        this.errorText = '';
    }

    _tempPayrollId: string = '';
    _tempDeletePayroll(){
        if(!confirm('Esta acción cancela el cálculo previo de este periodo.\nAsegúrese de no reiniciar una nómida que ya fue impresa y/o pagada.')) return toast('Se canceló la eliminación.',2000);
        this.payrollService._tempDeletePayroll(this._tempPayrollId).then(res => {
            toast('Se ha reiniciado el proceso correctamente. Puede volver a sacar el estimado.', 5000);
            this.loadText = 0;
            this.flagProcess = false;
            this.emitReceipts = false;
        });
        this._tempPayrollId = '';
    }
    carrierReports: any = {};
    getPayrollEstimate() {
        if(!this.permission.createAction) return toast('No tiene los permisos para sacar estimado.', 2000);
        this.flagProcess = true;

        /* let sub  = this.carrierReportService.getCarrierReportsByReportDate(Utils.convertDatefromISOStringtoObject(this.startDate)).subscribe(reps => {
            sub.unsubscribe();
            this.carrierReports = reps.reduce((acc, {employeeId: id, employees: es1, ...rep}) => {
                let {employees: es2=[]} = acc[id] || {};
                acc[id] = { ...rep, employees: [...es1.map(({id$}) => id$), ...es2] };
                return acc;
            }, {} );
            console.log(reps, this.carrierReports);
        }); */

        this.clearFolders();

        this.assistanceEmployee = [];

        if (this._startDate !== undefined && this._startDate !== '') {
            const initDate = Utils.convertDatefromISOStringtoObject(this._startDate);
            const endDate = Utils.convertDatefromISOStringtoObject(this._startDate);
            endDate.setDate(endDate.getDate() + 7);

            const dates = [];

            while (initDate < endDate) {;
                dates.push(String(Utils.getDateWhitoutTime(initDate)));
                initDate.setDate(initDate.getDate() + 1);
            }

            let payrollId = dates[0] + '_' + dates[(dates.length - 1)];
            this.gpSubs = this.payrollService.getPayroll(payrollId).subscribe(tempPayroll => {
                this.gpSubs.unsubscribe();

                if (tempPayroll === null) {
                    this.gsrbpSubs = this.assistanceReportService.getAssistanceReportsByPeriod(dates[0], dates[(dates.length - 1)])
                                                                                                            .subscribe(tmpAsRp => {
                        this.gsrbpSubs.unsubscribe();

                        if (tmpAsRp.length === dates.length) {
                            // Data to Validate
                            const iPayroll = [];

                            for (const idx in this.employeesInfo) {
                                if (iPayroll[idx] === undefined) {
                                    iPayroll[idx] = {
                                        id: idx,
                                        name: this.employeesInfo[idx].name,
                                        job: this.employeesInfo[idx].jobId,
                                        dates: dates,
                                        status: new Array(dates.length).fill(0),
                                        activities: new Array(dates.length).fill(''),
                                        advance: new Array(dates.length).fill(0)
                                    };
                                }
                            }

                            console.log('Start');

                            this.loadText = 1;

                            this.reviewAssistaceReportByDate(iPayroll, dates, 0);
                        } else {
                            this.flagProcess = false;
                            this.globalActionsPeriod.emit('toast');
                        }
                    });
                } else {
                    this.flagProcess = false;
                    this.globalActions.emit('toast');
                    this._tempPayrollId = payrollId;

                    this.showPayroll(dates);
                }
            });
        } else {
            this.flagProcess = false;
            this.globalActionsDates.emit('toast');
        }
    }

    reviewAssistaceReportByDate(iPayroll, dates, index) {
        console.log('Day : ' +  index + ' : ' + dates[index]);

        this.gareSubs = this.assistanceReportService.getAssistanceReportEmployees(dates[index]).subscribe(assistanceReportObj => {
            this.gareSubs.unsubscribe();

            const employeesData: any[] = assistanceReportObj[0].employees;
            //console.log('______*********___________________________');
            //console.log(employeesData);
            //console.log(employeesData)
            //let e = employeesData.find(({employeeId: id}) => id == 'Mj0Pai5fLvpTPxnoyr6y');
            //console.log(e, iPayroll['Mj0Pai5fLvpTPxnoyr6y']);
            //console.log(e, this.employeesPayrollReceipt['4wdbSw7ftRY5DHhtf8y4']);
            for (let item in employeesData) {
                if(!iPayroll[employeesData[item].employeeId]) continue;
                iPayroll[employeesData[item].employeeId].status[index] = employeesData[item].status;
                iPayroll[employeesData[item].employeeId].departmentId = this.employeesPayrollReceipt[employeesData[item].employeeId].department;
                iPayroll[employeesData[item].employeeId].appliesBonus = this.employeesPayrollReceipt[employeesData[item].employeeId].appliesBonus;

                if (employeesData[item].supervisorActivity !== undefined && employeesData[item].supervisorActivity !== "") {
                    iPayroll[employeesData[item].employeeId].activities[index] = employeesData[item].supervisorActivity;
                    iPayroll[employeesData[item].employeeId].advance[index] = employeesData[item].supervisorAdvance;
                }
            }

            if ((index + 1) === dates.length) {
                this.getFoldersData(iPayroll, dates);
            } else {
                this.reviewAssistaceReportByDate(iPayroll, dates, (index + 1));
            }
        });
    }

    getFoldersData(iPayroll, dates) {
        console.log('Validating data');

        this.loadText = 2;
        let existInconsistencies = 0;

        for (const idx in iPayroll) {
            iPayroll[idx].dates.forEach((iD, pos) => {
                if (iPayroll[idx].status[pos] === this.INCOMPLETE) {
                    existInconsistencies = 1;
                }
            });
        }

        this.assistanceEmployee = iPayroll;
        this.datesFolders = dates;

        if (existInconsistencies === 1) {
            this.openModal();
        } else {
            this.getPayrollData(0);
        }
    }

    openModal() {
        this.modalActions.emit({ action: 'modal', params: ['open'] });
    }

    closeModal(resp) {
        this.modalActions.emit({ action: 'modal', params: ['close'] });

        if (resp === 1) {
            this.flagProcess = false;
            this.loadText = 0;
        }
    }

    getPayrollData(resp) {
        if (resp === 1) {
            this.closeModal(0);
        }

        console.log('Folder Payroll');
        this.loadText = 3;

        const iPayrolls = this.assistanceEmployee;
        //console.log('_________________________________________');
        //console.log(iPayrolls);

        const payrolls = [];

        //console.log(iPayrolls['Mj0Pai5fLvpTPxnoyr6y'], this.jobsInfo, this.jobsInfo[iPayrolls['Mj0Pai5fLvpTPxnoyr6y'].job])
        for (const idx in iPayrolls) {
            const item = {
                employeeName: <string>iPayrolls[idx].name, dId: iPayrolls[idx].departmentId, aB: !!iPayrolls[idx].appliesBonus, totalAmount: '0.00', totalPlusBonus: '0.00', payroll1: '0.00', payroll2: '0.00',
                payroll3: '0.00', payroll4: '0.00', payroll5: '0.00', payroll6: '0.00', payroll7: '0.00'
            };

            const bSalary = (this.jobsInfo[iPayrolls[idx].job] || {baseSalary: 0}).baseSalary;
            let totalAmount = 0;

            iPayrolls[idx].dates.forEach((iD, pos) => {
                if (iPayrolls[idx].status[pos] === this.COMPLETE) {
                    let amountToPay = 0;

                    let ac = this.activitiesInfo[iPayrolls[idx].activities[pos]];
                    /* if (iPayrolls[idx].activities[pos] !== "" && ac) {
                        amountToPay = (iPayrolls[idx].advance[pos] / ac) * bSalary;
                    } else { */ //Antes se evaluaba el avance en actividad
                        amountToPay = bSalary;
                    //}

                    if (pos === 0) { item.payroll1 = Utils.money(amountToPay); }
                    if (pos === 1) { item.payroll2 = Utils.money(amountToPay); }
                    if (pos === 2) { item.payroll3 = Utils.money(amountToPay); }
                    if (pos === 3) { item.payroll4 = Utils.money(amountToPay); }
                    if (pos === 4) { item.payroll5 = Utils.money(amountToPay); }
                    if (pos === 5) { item.payroll6 = Utils.money(amountToPay); }
                    if (pos === 6) { item.payroll7 = Utils.money(amountToPay); }

                    
                    totalAmount = totalAmount + amountToPay;
                }
            });

            let getsBonus = () => {
                //console.log(item);
                return [1,2,3,4,5,6,7].reduce((acc, i) => acc && !(this.settings.businessDays[(7 + i - 1 + this.weekday)%7] && item[`payroll${i}`] == '0.00'), true );
            }
            let bonus = item.aB && getsBonus() && this.settings.bonus || 0;
            
            this.payrollTotal = this.payrollTotal + totalAmount;

            item.totalAmount = Utils.money(totalAmount);
            item.totalPlusBonus = Utils.money(totalAmount + bonus);

            if (Utils.strToNumber(item.totalPlusBonus) > 0) {
                this.employeesPayrollReceipt[idx].payroll = [item.payroll1, item.payroll2, item.payroll3, item.payroll4,
                                                             item.payroll5, item.payroll6, item.payroll7, item.totalAmount, Utils.money(bonus)];

                payrolls.push(item);
            }
        }

        this.dataPayroll = payrolls;
        this.lengthPayroll = this.dataPayroll.length;
        this.onChangeTablePayroll(this.configPayroll);

        const daysWeek = Utils.getWeekDayFromDates(this.datesFolders);
        const tableItem = document.getElementById('payrollSection').getElementsByTagName('table')[0] as HTMLTableElement;
        tableItem.rows[0].cells[2].innerHTML = daysWeek[0];
        tableItem.rows[0].cells[3].innerHTML = daysWeek[1];
        tableItem.rows[0].cells[4].innerHTML = daysWeek[2];
        tableItem.rows[0].cells[5].innerHTML = daysWeek[3];
        tableItem.rows[0].cells[6].innerHTML = daysWeek[4];
        tableItem.rows[0].cells[7].innerHTML = daysWeek[5];
        tableItem.rows[0].cells[8].innerHTML = daysWeek[6];

        this.getCarrierData(this.datesFolders);
    }

    getCarrierData(cDates) {
        console.log('Folder Carrier');
        this.loadText = 4;

        this.garebpSubs = this.assistanceReportService.getAssistanceReportEmployeesByPeriod(cDates[0], cDates[(cDates.length - 1)])
                                                                                                            .subscribe(tmpAsRp => {
            this.garebpSubs.unsubscribe();

            const iCarriers = { local: {}, foreign: {} };

            console.log(tmpAsRp)
            for (const idxAr in tmpAsRp) {
                const employeesData = tmpAsRp[idxAr].employees;

                const carrierNumber = { local: {}, foreign: {} };

                for (const item in employeesData) {
                    let {employeeId: eId} = employeesData[item];
                    let {cIsForeign=false} = this.employeesInfo[eId] || {};
                    let cType = cIsForeign ? 'foreign' : 'local';
                    if(cIsForeign){
                        if(!this.employeesPayrollReceipt[eId].carriedF) this.employeesPayrollReceipt[eId].carriedF = [];
                        this.employeesPayrollReceipt[eId].carriedF[idxAr] = employeesData[item].status ? this.cfCommission : 0;
                    }
                    if (employeesData[item].status) {
                        
                        const carrierReportEmployee = employeesData[item].carrierEmployee;

                        for (const i in carrierReportEmployee) {
                            let cId = carrierReportEmployee[i];
                            //let is = id == 'EHDrUPmY2AP2eRVwc2TT';
                            //console.log(id, this.employeesInfo[id].name);
                            //let is = employeesData[item].employeeName == 'AGUSTIN CORONADO MARTINEZ';
                            //if(is) console.log(employeesData[item])
                            
                            if (carrierNumber[cType][carrierReportEmployee[i]] === undefined) {
                                carrierNumber[cType][carrierReportEmployee[i]] = 1;
                            } else {
                                carrierNumber[cType][carrierReportEmployee[i]] = carrierNumber[cType][carrierReportEmployee[i]] + 1;
                            }
                        }
                    }
                }

                const position = cDates.indexOf(tmpAsRp[idxAr].reportDate);

                for (const idC in carrierNumber.local) {
                    if(!this.employeesInfo[idC]) continue;
                    if (iCarriers.local[idC] === undefined) {
                        iCarriers.local[idC] = {
                            name: this.employeesInfo[idC].name,
                            dates: cDates,
                            values: new Array(cDates.length).fill(0)
                        };
                    }

                    iCarriers.local[idC].values[position] = carrierNumber.local[idC];
                }
                for (const idC in carrierNumber.foreign) {
                    if(!this.employeesInfo[idC]) continue;
                    if (iCarriers.foreign[idC] === undefined) {
                        iCarriers.foreign[idC] = {
                            name: this.employeesInfo[idC].name,
                            dates: cDates,
                            values: new Array(cDates.length).fill(0)
                        };
                    }

                    iCarriers.foreign[idC].values[position] = carrierNumber.foreign[idC];
                }
            }

            const carriers = { local: [], foreign: [] };

            Object.keys(carriers).map(key => {
                let iCarriersK = iCarriers[key];
                for (const idx in iCarriersK) {
                    const item = {
                        carrierName: iCarriersK[idx].name, totalPersons: 0, totalAmount: '0.00',
                        carrier1: iCarriersK[idx].values[0], carrier2: iCarriersK[idx].values[1], carrier3: iCarriersK[idx].values[2],
                        carrier4: iCarriersK[idx].values[3], carrier5: iCarriersK[idx].values[4], carrier6: iCarriersK[idx].values[5],
                        carrier7: iCarriersK[idx].values[6]
                    };
    
                    const iPersons = iCarriersK[idx].values[0] + iCarriersK[idx].values[1] + iCarriersK[idx].values[2] + iCarriersK[idx].values[3] + iCarriersK[idx].values[4] + iCarriersK[idx].values[5] + iCarriersK[idx].values[6];
    
                    item.totalPersons = iPersons;
                    let totalAmount = iPersons * this.paymentPerPerson[key];
    
                    this.carrierTotal = this.carrierTotal + totalAmount;
    
                    item.totalAmount = Utils.money(totalAmount);
    
                    this.employeesPayrollReceipt[idx][key == 'local' ? 'carrier' : 'carrierF'] = [
                        Utils.money(item.carrier1 * this.paymentPerPerson[key]), Utils.money(item.carrier2 * this.paymentPerPerson[key]), Utils.money(item.carrier3 * this.paymentPerPerson[key]),
                        Utils.money(item.carrier4 * this.paymentPerPerson[key]), Utils.money(item.carrier5 * this.paymentPerPerson[key]), Utils.money(item.carrier6 * this.paymentPerPerson[key]), Utils.money(item.carrier7 * this.paymentPerPerson[key]),
                        item.totalAmount
                    ];
    
                    carriers[key].push(item);
                }
            })

            this.dataCarrier = carriers.local;
            this.dataCarrierF = carriers.foreign;
            this.lengthCarrier = this.dataCarrier.length;
            this.lengthCarrierF = this.dataCarrierF.length;
            this.onChangeTableCarrier(this.configCarrier);
            this.onChangeTableCarrierF(this.configCarrier);

            const daysWeek = Utils.getWeekDayFromDates(this.datesFolders);
            const tableItem = document.getElementById('carrierSection').getElementsByTagName('table')[0] as HTMLTableElement;
            tableItem.rows[0].cells[3].innerHTML = daysWeek[0];
            tableItem.rows[0].cells[4].innerHTML = daysWeek[1];
            tableItem.rows[0].cells[5].innerHTML = daysWeek[2];
            tableItem.rows[0].cells[6].innerHTML = daysWeek[3];
            tableItem.rows[0].cells[7].innerHTML = daysWeek[4];
            tableItem.rows[0].cells[8].innerHTML = daysWeek[5];
            tableItem.rows[0].cells[9].innerHTML = daysWeek[6];

            this.getOverData(cDates);
        });
    }

    getOverData(oDates) {
        console.log('Folder Overtime');
        this.loadText = 4;

        const initDate = Utils.convertDatefromISOStringtoObject(oDates[0]);
        const endDate = Utils.convertDatefromISOStringtoObject(oDates[oDates.length - 1]);

        this.gobrdSubs = this.overtimeService.getOvertimesByRangeDate(initDate, endDate).subscribe(tempOvetimes => {
            this.gobrdSubs.unsubscribe();

            const iOvertimes = [];

            for (const idx in tempOvetimes) {
                const itemId = tempOvetimes[idx].employeeId;

                // Check if employeeInfo exists for the given itemId
                if (this.employeesInfo[itemId] === undefined) {
                console.error(`No employee info found for itemId: ${itemId}`);
                continue; // Skip to the next iteration
                }

                if (iOvertimes[itemId] === undefined) {
                    iOvertimes[itemId] = {
                        name: this.employeesInfo[itemId].name,
                        dates: oDates,
                        values: new Array(oDates.length).fill(0),
                        job: this.employeesInfo[itemId].jobId
                    };
                }

                const oWorkDate = String(Utils.getDateWhitoutTime(tempOvetimes[idx].workDate));
                const position = iOvertimes[itemId].dates.indexOf(oWorkDate);
                iOvertimes[itemId].values[position] = iOvertimes[itemId].values[position] + tempOvetimes[idx].hours;
            }

            const overtimes = [];

            for (const idx in iOvertimes) {
                const item = {
                    employeeName: iOvertimes[idx].name,
                    totalHours: 0,
                    totalAmount: '0.00',
                    over1: iOvertimes[idx].values[0],
                    over2: iOvertimes[idx].values[1],
                    over3: iOvertimes[idx].values[2],
                    over4: iOvertimes[idx].values[3],
                    over5: iOvertimes[idx].values[4],
                    over6: iOvertimes[idx].values[5],
                    over7: iOvertimes[idx].values[6]
                };

                const iHours = iOvertimes[idx].values[0] + iOvertimes[idx].values[1] + iOvertimes[idx].values[2] + iOvertimes[idx].values[3] +
                               iOvertimes[idx].values[4] + iOvertimes[idx].values[5] + iOvertimes[idx].values[6];

                console.log(iOvertimes[idx].job, this.jobsInfo[iOvertimes[idx].job])
                const payPerHour = this.jobsInfo[iOvertimes[idx].job].extraSalary * this.multiplicationFactor;

                item.totalHours = iHours;
                let totalAmount = iHours * payPerHour;

                this.overtimeTotal = this.overtimeTotal + totalAmount;

                item.totalAmount = Utils.money(totalAmount);

                this.employeesPayrollReceipt[idx].overtime = [Utils.money(item.over1 * payPerHour), Utils.money(item.over2 * payPerHour),
                                                              Utils.money(item.over3 * payPerHour), Utils.money(item.over4 * payPerHour),
                                                              Utils.money(item.over5 * payPerHour), Utils.money(item.over6 * payPerHour),
                                                              Utils.money(item.over7 * payPerHour), item.totalAmount];

                overtimes.push(item);
            }

            this.dataOver = overtimes;
            this.lengthOver = this.dataOver.length;
            this.onChangeTableOver(this.configOver);

            const daysWeek = Utils.getWeekDayFromDates(this.datesFolders);
            const tableItem = document.getElementById('overtimeSection').getElementsByTagName('table')[0] as HTMLTableElement;
            tableItem.rows[0].cells[3].innerHTML = daysWeek[0];
            tableItem.rows[0].cells[4].innerHTML = daysWeek[1];
            tableItem.rows[0].cells[5].innerHTML = daysWeek[2];
            tableItem.rows[0].cells[6].innerHTML = daysWeek[3];
            tableItem.rows[0].cells[7].innerHTML = daysWeek[4];
            tableItem.rows[0].cells[8].innerHTML = daysWeek[5];
            tableItem.rows[0].cells[9].innerHTML = daysWeek[6];

            this.getLoanData();
        });
    }

    getLoanData(){
        console.log('Folder Loan');
        this.loadText = 6;

        this.galSubs = this.loanService.getActiveLoans().subscribe(tempLoans => {
            this.galSubs.unsubscribe();

            const iLoans = [];

            for (const idx in tempLoans) {
                const itemId = tempLoans[idx].employeeId;

                let iPayment;

                if (tempLoans[idx].discountPerPayroll > tempLoans[idx].remainingAmount) {
                    iPayment = tempLoans[idx].remainingAmount;
                } else {
                    iPayment = tempLoans[idx].discountPerPayroll;
                }

                // Check if employeeInfo exists for the given itemId
                if (this.employeesInfo[itemId] === undefined) {
                console.error(`No employee info found for itemId: ${itemId}`);
                continue; // Skip to the next iteration
                }

                if (iLoans[itemId] === undefined) {
                    iLoans[itemId] = {
                        name: this.employeesInfo[itemId].name,
                        payment: iPayment,
                        id: tempLoans[idx].id$,
                        remaining: tempLoans[idx].remainingAmount
                    };
                } else {
                    iLoans[itemId].payment = iLoans[itemId].payment + iPayment;
                }
            }

            const loans = [];

            for (const idx in iLoans) {
                const item = {
                    employeeName: iLoans[idx].name,
                    totalAmount: '0.00',
                    id: iLoans[idx].id,
                    remaining: iLoans[idx].remaining,
                    payment: iLoans[idx].payment
                };

                let totalAmount = iLoans[idx].payment;

                this.loanTotal = this.loanTotal + totalAmount;

                item.totalAmount = Utils.money(totalAmount);

                this.employeesPayrollReceipt[idx].loan = [item.totalAmount];

                loans.push(item);
            }

            this.dataLoan = loans;
            this.lengthLoan = this.dataLoan.length;
            this.onChangeTableLoan(this.configLoan);

            this.getSummaryData();
        });
    }

    getSummaryData() {
        console.log('Folder Summary');
        this.loadText = 7;

        this.estimateTotal = this.payrollTotal + this.carrierTotal + this.overtimeTotal + (this.loanTotal * -1);

        const pt = Utils.money(this.payrollTotal);
        const ct = Utils.money(this.carrierTotal);
        const ot = Utils.money(this.overtimeTotal);
        const lt = Utils.money(this.loanTotal * -1);
        const et = Utils.money(this.estimateTotal);

        const concepts = [
            { conceptName: 'Nómina', totalAmount: pt },
            { conceptName: 'Transporte', totalAmount: ct },
            { conceptName: 'Horas Extras', totalAmount: ot },
            { conceptName: 'Regreso Préstamos', totalAmount: lt },
            { conceptName: '&nbsp;', totalAmount: '&nbsp;' },
            { conceptName: 'Total Estimado', totalAmount: et }
        ];

        this.dataEstimate = concepts;
        this.lengthEstimate = this.dataEstimate.length;
        this.onChangeTableEstimate(this.configEstimate);

        this.flagProcess = false;
        this.loadText = 0;
        this.processEnd = true;
    }

    clearFolders() {
        this.dataPayroll = [];
        this.lengthPayroll = this.dataPayroll.length;
        this.onChangeTablePayroll(this.configPayroll);

        this.dataCarrier = [];
        this.lengthCarrier = this.dataCarrier.length;
        this.onChangeTableCarrier(this.configCarrier);

        this.dataCarrierF = [];
        this.lengthCarrier = this.dataCarrierF.length;
        this.onChangeTableCarrier(this.configCarrierF);

        this.dataOver = [];
        this.lengthOver = this.dataOver.length;
        this.onChangeTableOver(this.configOver);

        this.dataLoan = [];
        this.lengthLoan = this.dataLoan.length;
        this.onChangeTableLoan(this.configLoan);

        this.dataEstimate = [];
        this.lengthEstimate = this.dataEstimate.length;
        this.onChangeTableEstimate(this.configEstimate);

        this.processEnd = false;
        this.flagPayrollProcess = false;

        this.emitReceipts = false;

        this.payrollTotal = 0;
        this.carrierTotal = 0;
        this.overtimeTotal = 0;
        this.loanTotal = 0;
        this.estimateTotal = 0;

        for (let idx in this.employeesPayrollReceipt) {
            this.employeesPayrollReceipt[idx].payroll = null;
            this.employeesPayrollReceipt[idx].carrier = null;
            this.employeesPayrollReceipt[idx].carrierF = null;
            this.employeesPayrollReceipt[idx].carriedF = null;
            this.employeesPayrollReceipt[idx].overtime = null;
            this.employeesPayrollReceipt[idx].loan = null;
        }

        this.closedPayroll = false;
        this.acceptanceUser = '';
        this.acceptanceDate = '';
    }

    openPayrollModal() {
        if(!this.permission.createAction) return toast('No tiene los permisos para generar.', 2000);
        this.flagPayrollProcess = true;

        this.payrollModalActions.emit({ action: 'modal', params: ['open'] });
    }

    closePayrollModal(resp) {
        this.payrollModalActions.emit({ action: 'modal', params: ['close'] });

        if (resp === 1) {
            this.flagPayrollProcess = false;
        }
    }

    savePayroll() {
        if(!this.permission.createAction) return toast('No tiene los permisos para continuar.', 2000);
        console.log('Save payroll');

        this.closePayrollModal(0);

        const currentDate = new Date();

        const payrollJson = {
            active: true,
            acceptanceDate: currentDate,
            acceptanceUser: this.userSession['email'],
            createdAt: currentDate,
            endDate: this.datesFolders[this.datesFolders.length - 1],
            startDate: this.datesFolders[0],
            status: 1,
            updatedAt: currentDate
        };

        const payrollId = this.datesFolders[0] + '_' + this.datesFolders[this.datesFolders.length - 1];

        this.payrollService.postPayroll(payrollId, payrollJson).then(responseId => {
            if (responseId !== '') {
                let counter = 0;
                const employeesPayroll = [];

                for (let idxEpr in this.employeesPayrollReceipt) {
                    const ep = this.employeesPayrollReceipt[idxEpr];
                    const hasBasePay = ep.payroll && (Utils.strToNumber(ep.payroll[7]) > 0 || ep.payroll[8] > 0);
                    const hasCarrier = ep.carrier && Utils.strToNumber(ep.carrier[7]) > 0;
                    const hasCarrierF = ep.carrierF && Utils.strToNumber(ep.carrierF[7]) > 0;
                    const hasOvertime = ep.overtime && Utils.strToNumber(ep.overtime[7]) > 0;
                    const hasLoan = ep.loan && Utils.strToNumber(ep.loan[0]) > 0;
                    const hasCarriedF = ep.carriedF && ep.carriedF.some(v => v > 0);

                    if (!hasBasePay && !hasCarrier && !hasCarrierF && !hasOvertime && !hasLoan && !hasCarriedF) {
                        continue;
                    }

                    counter = counter + 1;

                    const employeeJson = {
                        createdAt: currentDate,
                        dates: this.datesFolders,
                        employeeId: idxEpr,
                        employeeName: this.employeesPayrollReceipt[idxEpr].name || null,
                        employeeFolio: this.employeesPayrollReceipt[idxEpr].folio || null,
                        employeeDepartmentId: this.employeesPayrollReceipt[idxEpr].department || null,
                        payroll: this.employeesPayrollReceipt[idxEpr].payroll || null,
                        carrier: this.employeesPayrollReceipt[idxEpr].carrier || null,
                        carrierF: this.employeesPayrollReceipt[idxEpr].carrierF || null,
                        carriedF: this.employeesPayrollReceipt[idxEpr].carriedF && [...this.employeesPayrollReceipt[idxEpr].carriedF].map(u => u || 0) || null,
                        overtime: this.employeesPayrollReceipt[idxEpr].overtime || null,
                        loan: this.employeesPayrollReceipt[idxEpr].loan || null,
                        updatedAt: currentDate
                    };

                    employeesPayroll.push(employeeJson);
                }

                console.log('Final employees to save count:', counter);
                const sizeBatch = 500;
                const numberBatchs = Math.floor(counter / sizeBatch) + (counter % sizeBatch === 0 ? 0 : 1);

                if (counter > 0) {
                    this.processEmployees(this, employeesPayroll, counter, sizeBatch, numberBatchs, 1, responseId);
                } else {
                    console.log('No employees to save, skipping to updateLoans');
                    this.updateLoans(this, responseId);
                }
            }
        });
    }

    processEmployees(self, employees, totalEmployees, itemsToProcess, totalOfProcess, iProcess, payrollId) {
        console.log('Iteration : ' + iProcess + ' / ' + totalOfProcess);

        if (totalOfProcess === iProcess) {
            const arrayEmployees = Object.values(employees);

            self.payrollService.postPayrollEmployeesAtomic(payrollId, arrayEmployees).then(function() {
                self.updateLoans(self, payrollId);
            });
        } else {
            const arrayEmployees = Object.values(employees);
            const processingEmployees = arrayEmployees.splice(0, itemsToProcess);
            const remainingEmployees = arrayEmployees.splice(0, (totalEmployees - itemsToProcess));

            self.payrollService.postPayrollEmployeesAtomic(payrollId, processingEmployees).then(function() {
                self.processEmployees(self, remainingEmployees, (totalEmployees - itemsToProcess), itemsToProcess,
                                      totalOfProcess, (iProcess + 1), payrollId);
            });
        }
    }

    updateLoans(self, payrollId) {
        console.log('Recalculate loans amounts');

        this.loanService.putLoanAtomic(this.dataLoan, payrollId).then(function() {
            self.updateAssistanceReports(self);
        });
    }

    updateAssistanceReports(self) {
        console.log('Close assistance reports');

        this.assistanceReportService.putAssistanceReportAtomic(this.datesFolders).then(function() {
            const logJson = {
                actionDate: new Date(),
                actionDescription: 'El usuario ' + self.userSession['email'] +
                                  ' generó la nómina para el periodo del ' + self.datesFolders[0] +
                                  ' al ' + self.datesFolders[self.datesFolders.length - 1],
                employeeId: '',
                userId: self.userSession['email'],
                objectId: self.datesFolders[0] + '_' + self.datesFolders[self.datesFolders.length - 1],
                objectDescription: 'Generación de Nómina'
            };

            self.logService.postLog(logJson).then(resp => {
            });

            self.getPayrollReceipts(self.datesFolders, self.employeesPayrollReceipt);
        });
    }

    showPayroll(iDates) {
        this.gpeSubs = this.payrollService.getPayrollEmployees(iDates[0] + '_' + iDates[(iDates.length - 1)], ).subscribe(payrollObj => {
            this.gpeSubs.unsubscribe();

            this.closedPayroll = true;

            this.acceptanceUser = payrollObj[0].acceptanceUser;
            this.acceptanceDate = Utils.getDateTime(payrollObj[0].acceptanceDate);
            const employeesData = payrollObj[0].employees;
            console.log(employeesData);

            const employeesReceipt = [];

            for (const idx in employeesData) {
                employeesReceipt[employeesData[idx].employeeId] = {
                    name: employeesData[idx].employeeName,
                    folio: employeesData[idx].employeeFolio,
                    department: employeesData[idx].employeeDepartmentId,
                    payroll: employeesData[idx].payroll,
                    carrier: employeesData[idx].carrier,
                    carrierF: employeesData[idx].carrierF,
                    carriedF: employeesData[idx].carriedF,
                    overtime: employeesData[idx].overtime,
                    loan: employeesData[idx].loan
                };
            }
            console.log(employeesReceipt);

            this.getPayrollReceipts(iDates, employeesReceipt);
        });
    }

    getPayrollReceipts(periodDates, employeesPayroll) {
        console.log('Make pdf');

        let periodEmployeesPayroll = [];

        console.log('getPayrollReceipts started. Employees count:', Object.keys(employeesPayroll).length);
        for (let idx in employeesPayroll) {
            const ep = employeesPayroll[idx];
            const hasBasePay = ep.payroll && (Utils.strToNumber(ep.payroll[7]) > 0 || Utils.strToNumber(ep.payroll[8]) > 0);
            const hasCarrier = ep.carrier && Utils.strToNumber(ep.carrier[7]) > 0;
            const hasCarrierF = ep.carrierF && Utils.strToNumber(ep.carrierF[7]) > 0;
            const hasOvertime = ep.overtime && Utils.strToNumber(ep.overtime[7]) > 0;
            const hasLoan = ep.loan && Utils.strToNumber(ep.loan[0]) > 0;
            const hasCarriedF = ep.carriedF && ep.carriedF.some(v => v > 0);

            if (!hasBasePay && !hasCarrier && !hasCarrierF && !hasOvertime && !hasLoan && !hasCarriedF) {
                continue;
            }

            if (ep.department !== '' && ep.department !== undefined) {
                ep.department = this.departmentsInfo[ep.department];
            }

            periodEmployeesPayroll.push(ep);
        }

        // Sort employees by department and name
        function dynamicSort(property) {
            let sortOrder = 1;
            if (property[0] === '-') {
                sortOrder = -1;
                property = property.substr(1);
            }
            return function (a, b) {
                let result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
                return result * sortOrder;
            }
        }
        function dynamicSortMultiple(array) {
            let props = array;
            return function (obj1, obj2) {
                let i = 0, result = 0, numberOfProperties = props.length;
                while(result === 0 && i < numberOfProperties) {
                    result = dynamicSort(props[i])(obj1, obj2);
                    i++;
                }
                return result;
            }
        }

        console.log(periodEmployeesPayroll);
        periodEmployeesPayroll.sort(dynamicSortMultiple(['department', 'name']));
        console.log(periodEmployeesPayroll);

        // Iterate employees
        const daysWeek = Utils.getWeekDayFromDates(periodDates);

        let content = [];

        let consecutiveNumber = 1;

        let iDepartment = periodEmployeesPayroll.length > 0 ? periodEmployeesPayroll[0].department : '';

        for (let idx in periodEmployeesPayroll) {
            let totalPayroll = 0;

            if (iDepartment !== periodEmployeesPayroll[idx].department) {
                content.push({
                    text: ' ',
                    pageBreak: 'after'
                });

                iDepartment = periodEmployeesPayroll[idx].department;
            }

            content.push({ text: 'Empleado:   ' + periodEmployeesPayroll[idx].name, style: ['textNormal'] });
            content.push({ text: 'Departamento:   ' + periodEmployeesPayroll[idx].department, style: ['textNormal'] });
            content.push({ text: 'Folio:   ' + periodEmployeesPayroll[idx].folio, style: ['textNormal'] });
            content.push({ text: 'Semana de Nómina:   ' + Utils.getDayMonthYearFromISODate(periodDates[0]) +
                           ' al ' + Utils.getDayMonthYearFromISODate(periodDates[6]), style: ['textNormal'] });
            content.push({ text: 'Consecutivo   ' + consecutiveNumber, style: ['textNormal', 'alignRight'] });

            let body = [];

            body.push([
                { text: ' ', style: ['textNormal'] },
                { text: daysWeek[0], style: ['textNormal'] },
                { text: daysWeek[1], style: ['textNormal'] },
                { text: daysWeek[2], style: ['textNormal'] },
                { text: daysWeek[3], style: ['textNormal'] },
                { text: daysWeek[4], style: ['textNormal'] },
                { text: daysWeek[5], style: ['textNormal'] },
                { text: daysWeek[6], style: ['textNormal'] },
                { text: 'Total', style: ['textNormal'] }
            ]);

            if (periodEmployeesPayroll[idx].payroll !== null) {
                body.push([
                    { text: 'Días trabajados', style: ['textNormal'] },
                    { text: periodEmployeesPayroll[idx].payroll[0], style: ['textNormal'] },
                    { text: periodEmployeesPayroll[idx].payroll[1], style: ['textNormal'] },
                    { text: periodEmployeesPayroll[idx].payroll[2], style: ['textNormal'] },
                    { text: periodEmployeesPayroll[idx].payroll[3], style: ['textNormal'] },
                    { text: periodEmployeesPayroll[idx].payroll[4], style: ['textNormal'] },
                    { text: periodEmployeesPayroll[idx].payroll[5], style: ['textNormal'] },
                    { text: periodEmployeesPayroll[idx].payroll[6], style: ['textNormal'] },
                    { text: periodEmployeesPayroll[idx].payroll[7], style: ['textNormal'] }
                ]);

                totalPayroll = totalPayroll + Utils.strToNumber(periodEmployeesPayroll[idx].payroll[7]);
            } else {
                body.push([
                    { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] },
                    { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] },
                    { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] }
                ]);
            }

            if (periodEmployeesPayroll[idx].overtime !== null) {
                body.push([
                    { text: 'Horas Extras', style: ['textNormal'] },
                    { text: periodEmployeesPayroll[idx].overtime[0], style: ['textNormal'] },
                    { text: periodEmployeesPayroll[idx].overtime[1], style: ['textNormal'] },
                    { text: periodEmployeesPayroll[idx].overtime[2], style: ['textNormal'] },
                    { text: periodEmployeesPayroll[idx].overtime[3], style: ['textNormal'] },
                    { text: periodEmployeesPayroll[idx].overtime[4], style: ['textNormal'] },
                    { text: periodEmployeesPayroll[idx].overtime[5], style: ['textNormal'] },
                    { text: periodEmployeesPayroll[idx].overtime[6], style: ['textNormal'] },
                    { text: periodEmployeesPayroll[idx].overtime[7], style: ['textNormal'] }
                ]);

                totalPayroll = totalPayroll + Utils.strToNumber(periodEmployeesPayroll[idx].overtime[7]);
            } else {
                body.push([
                    { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] },
                    { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] },
                    { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] }
                ]);
            }

            if (periodEmployeesPayroll[idx].carrier !== null) {
                body.push([
                    { text: 'Com. Transporte L', style: ['textNormal'] },
                    { text: periodEmployeesPayroll[idx].carrier[0], style: ['textNormal'] },
                    { text: periodEmployeesPayroll[idx].carrier[1], style: ['textNormal'] },
                    { text: periodEmployeesPayroll[idx].carrier[2], style: ['textNormal'] },
                    { text: periodEmployeesPayroll[idx].carrier[3], style: ['textNormal'] },
                    { text: periodEmployeesPayroll[idx].carrier[4], style: ['textNormal'] },
                    { text: periodEmployeesPayroll[idx].carrier[5], style: ['textNormal'] },
                    { text: periodEmployeesPayroll[idx].carrier[6], style: ['textNormal'] },
                    { text: periodEmployeesPayroll[idx].carrier[7], style: ['textNormal'] }
                ]);

                totalPayroll = totalPayroll + Utils.strToNumber(periodEmployeesPayroll[idx].carrier[7]);
            } else {
                body.push([
                    { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] },
                    { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] },
                    { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] }
                ]);
            }

            if (periodEmployeesPayroll[idx].carrierF) {
                body.push([
                    { text: 'Com. Transporte F', style: ['textNormal'] },
                    { text: periodEmployeesPayroll[idx].carrierF[0], style: ['textNormal'] },
                    { text: periodEmployeesPayroll[idx].carrierF[1], style: ['textNormal'] },
                    { text: periodEmployeesPayroll[idx].carrierF[2], style: ['textNormal'] },
                    { text: periodEmployeesPayroll[idx].carrierF[3], style: ['textNormal'] },
                    { text: periodEmployeesPayroll[idx].carrierF[4], style: ['textNormal'] },
                    { text: periodEmployeesPayroll[idx].carrierF[5], style: ['textNormal'] },
                    { text: periodEmployeesPayroll[idx].carrierF[6], style: ['textNormal'] },
                    { text: periodEmployeesPayroll[idx].carrierF[7], style: ['textNormal'] }
                ]);

                totalPayroll = totalPayroll + Utils.strToNumber(periodEmployeesPayroll[idx].carrierF[7]);
            } else {
                body.push([
                    { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] },
                    { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] },
                    { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] }
                ]);
            }

            if (periodEmployeesPayroll[idx].carriedF) {
                body.push([
                    { text: 'Comisión', style: ['textNormal'] },
                    { text: Utils.money(periodEmployeesPayroll[idx].carriedF[0] || 0), style: ['textNormal'] },
                    { text: Utils.money(periodEmployeesPayroll[idx].carriedF[1] || 0), style: ['textNormal'] },
                    { text: Utils.money(periodEmployeesPayroll[idx].carriedF[2] || 0), style: ['textNormal'] },
                    { text: Utils.money(periodEmployeesPayroll[idx].carriedF[3] || 0), style: ['textNormal'] },
                    { text: Utils.money(periodEmployeesPayroll[idx].carriedF[4] || 0), style: ['textNormal'] },
                    { text: Utils.money(periodEmployeesPayroll[idx].carriedF[5] || 0), style: ['textNormal'] },
                    { text: Utils.money(periodEmployeesPayroll[idx].carriedF[6] || 0), style: ['textNormal'] },
                    { text: Utils.money(periodEmployeesPayroll[idx].carriedF.reduce((acc, cur) => acc + (cur || 0), 0)), style: ['textNormal'] }
                ]);

                totalPayroll = totalPayroll + Utils.strToNumber(periodEmployeesPayroll[idx].carriedF.reduce((acc, cur) => acc + cur, 0));
            } else {
                body.push([
                    { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] },
                    { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] },
                    { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] }
                ]);
            }

            if (periodEmployeesPayroll[idx].loan !== null) {
                body.push([
                    { text: 'Regr. Préstamo', style: ['textNormal'] },
                    { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] },
                    { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] },
                    { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] },
                    { text: ' ', style: ['textNormal'] },
                    { text: periodEmployeesPayroll[idx].loan[0], style: ['textNormal'] }
                ]);

                totalPayroll = totalPayroll - Utils.strToNumber(periodEmployeesPayroll[idx].loan[0]);
            } else {
                body.push([
                    { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] },
                    { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] },
                    { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] }, { text: ' ', style: ['textNormal'] }
                ]);
            }

            content.push({
                table: {
                    headerRows: 1,
                    widths: ['*', '10%', '10%', '10%', '10%', '10%', '10%', '10%', '10%'],
                    body: body
                }
            });

            content.push({ text: 'Total semana:   ' + Utils.money(totalPayroll), style: ['textHead', 'alignRight'] });
            let bonus = (periodEmployeesPayroll[idx].payroll !== null) ? (Utils.strToNumber(periodEmployeesPayroll[idx].payroll[8]) || 0) : 0;
            content.push({ text: 'Bono:   ' + Utils.money(bonus), style: ['textHead', 'alignRight'] });
            content.push({ text: 'Pago de nómina:   ' + Utils.money(totalPayroll + bonus), style: ['textHead', 'alignRight'] });

            content.push({
                columns: [
                    { width: '*', text: '__________________________________________________', style : ['textNormal', 'alignCenter'] },
                    { width: '*', text: ' ', style : ['textNormal'] }
                ],
                columnGap: 10
            });

            content.push({
                columns: [
                    { width: '*', text: ' Nombre y Firma ', style : ['textNormal', 'alignCenter'] },
                    { width: '*', text: 'Fecha:   ______________________________', style : ['textNormal', 'alignRight'] }
                ],
                columnGap: 10
            });

            if (consecutiveNumber % 4 !== 0) {
                content.push({
                    text: '--------------------------------------------------------------------------------' +
                          '--------------------------------------------------------------------------------',
                    style: ['textNormal', 'alignCenter']
                });
            }

            consecutiveNumber = consecutiveNumber + 1;
        }

        this.pdfmake.docDefinition = <any>{
            content: content,
            styles: {
                textNormal: {
                    fontSize: 10
                },
                textHead: {
                    fontSize: 12
                },
                alignRight: {
                    alignment: 'right'
                },
                alignCenter: {
                    alignment: 'center'
                }
            }
        };

        console.log('getPayrollReceipts finished successfully. periodEmployeesPayroll count:', periodEmployeesPayroll.length);
        this.emitReceipts = true;
    }

    openPdf() {
        this.pdfmake.open();
    }

    // *************** Table functionality *************** //
    changePagePayroll(page: any, data: Array<any> = this.dataPayroll): Array<any> {
        let start = (page.page - 1) * page.itemsPerPage;
        let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;

        return data.slice(start, end);
    }

    changeSortPayroll(data: any, config: any): any {
        if (!config.sorting) {
            return data;
        }

        let columns = this.configPayroll.sorting.columns;
        let columnName: string;
        let sort: string;

        for (let i = 0; i < columns.length; i++) {
            if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
                columnName = columns[i].name;
                sort = columns[i].sort;
            }
        }

        if (!columnName) {
            return data;
        }

        // simple sorting
        return data.sort((previous: any, current: any) => {
            let p = previous[columnName];
            let c = current[columnName];

            if (p != null && c != null && !isNaN(Utils.strToNumber(p.toString())) && !isNaN(Utils.strToNumber(c.toString()))) {
                p = Utils.strToNumber(p.toString());
                c = Utils.strToNumber(c.toString());
            }

            if (p > c) {
                return sort === 'desc' ? -1 : 1;
            } else if (p < c) {
                return sort === 'asc' ? -1 : 1;
            }

            return 0;
        });
    }

    changeFilterPayroll(data: any, config: any): any {
        let filteredData: Array<any> = data;

        this.columnsPayroll.forEach((column: any) => {
            if (column.filtering) {
                filteredData = filteredData.filter((item: any) => {
                    return item[column.name].match(column.filtering.filterString);
                });
            }
        });

        if (!config.filtering) {
            return filteredData;
        }

        if (config.filtering.columnName) {
            return filteredData.filter((item: any) => item[config.filtering.columnName].match(this.configPayroll.filtering.filterString));
        }

        let tempArray: Array<any> = [];

        filteredData.forEach((item: any) => {
            let flag = false;

            this.columnsPayroll.forEach((column: any) => {
                if (item[column.name] &&
                    item[column.name].toString().toLowerCase().match(this.configPayroll.filtering.filterString.toLowerCase())) {
                    flag = true;
                }
            });

            if (flag) {
                tempArray.push(item);
            }
        });

        filteredData = tempArray;

        return filteredData;
    }

    onChangeTablePayroll(config: any=this.configPayroll, page: any = {page: this.pagePayroll, itemsPerPage: this.itemsPerPagePayroll}): any {
        if (config.filtering) {
            Object.assign(this.configPayroll.filtering, config.filtering);
        }

        if (config.sorting) {
            Object.assign(this.configPayroll.sorting, config.sorting);
        }

        let filteredData = this.changeFilterPayroll(this.dataPayroll, this.configPayroll);
        let sortedData = this.changeSortPayroll(filteredData, this.configPayroll).filter(({dId}) => !this.departmentSelected || dId == this.departmentSelected );

        //console.log('__________________________________________________________________');
        //console.log(sortedData);
        this.rowsPayroll = page && config.paging ? this.changePagePayroll(page, sortedData) : sortedData;
        this.lengthPayroll = sortedData.length;
    }

    changePageCarrier(page: any, data: Array<any> = this.dataCarrier): Array<any> {
        let start = (page.page - 1) * page.itemsPerPage;
        let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;

        return data.slice(start, end);
    }

    changeSortCarrier(data: any, config: any): any {
        if (!config.sorting) {
            return data;
        }

        let columns = this.configCarrier.sorting.columns;
        let columnName: string;
        let sort: string;

        for (let i = 0; i < columns.length; i++) {
            if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
                columnName = columns[i].name;
                sort = columns[i].sort;
            }
        }

        if (!columnName) {
            return data;
        }

        // simple sorting
        return data.sort((previous: any, current: any) => {
            let p = previous[columnName];
            let c = current[columnName];

            if (p != null && c != null && !isNaN(Utils.strToNumber(p.toString())) && !isNaN(Utils.strToNumber(c.toString()))) {
                p = Utils.strToNumber(p.toString());
                c = Utils.strToNumber(c.toString());
            }

            if (p > c) {
                return sort === 'desc' ? -1 : 1;
            } else if (p < c) {
                return sort === 'asc' ? -1 : 1;
            }

            return 0;
        });
    }

    changeFilterCarrier(data: any, config: any): any {
        let filteredData: Array<any> = data;

        this.columnsCarrier.forEach((column: any) => {
            if (column.filtering) {
                filteredData = filteredData.filter((item: any) => {
                    return item[column.name].match(column.filtering.filterString);
                });
            }
        });

        if (!config.filtering) {
            return filteredData;
        }

        if (config.filtering.columnName) {
            return filteredData.filter((item: any) => item[config.filtering.columnName].match(this.configCarrier.filtering.filterString));
        }

        let tempArray: Array<any> = [];

        filteredData.forEach((item: any) => {
            let flag = false;

            this.columnsCarrier.forEach((column: any) => {
                if (item[column.name] &&
                    item[column.name].toString().toLowerCase().match(this.configCarrier.filtering.filterString.toLowerCase())) {
                    flag = true;
                }
            });

            if (flag) {
                tempArray.push(item);
            }
        });

        filteredData = tempArray;

        return filteredData;
    }

    onChangeTableCarrier(config: any, page: any = {page: this.pageCarrier, itemsPerPage: this.itemsPerPageCarrier}): any {
        if (config.filtering) {
            Object.assign(this.configCarrier.filtering, config.filtering);
        }

        if (config.sorting) {
            Object.assign(this.configCarrier.sorting, config.sorting);
        }

        let filteredData = this.changeFilterCarrier(this.dataCarrier, this.configCarrier);
        let sortedData = this.changeSortCarrier(filteredData, this.configCarrier);

        this.rowsCarrier = page && config.paging ? this.changePageCarrier(page, sortedData) : sortedData;
        this.lengthCarrier = sortedData.length;
    }

    changePageCarrierF(page: any, data: Array<any> = this.dataCarrierF): Array<any> {
        let start = (page.page - 1) * page.itemsPerPage;
        let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;

        return data.slice(start, end);
    }

    changeSortCarrierF(data: any, config: any): any {
        if (!config.sorting) {
            return data;
        }

        let columns = this.configCarrierF.sorting.columns;
        let columnName: string;
        let sort: string;

        for (let i = 0; i < columns.length; i++) {
            if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
                columnName = columns[i].name;
                sort = columns[i].sort;
            }
        }

        if (!columnName) {
            return data;
        }

        // simple sorting
        return data.sort((previous: any, current: any) => {
            let p = previous[columnName];
            let c = current[columnName];

            if (p != null && c != null && !isNaN(Utils.strToNumber(p.toString())) && !isNaN(Utils.strToNumber(c.toString()))) {
                p = Utils.strToNumber(p.toString());
                c = Utils.strToNumber(c.toString());
            }

            if (p > c) {
                return sort === 'desc' ? -1 : 1;
            } else if (p < c) {
                return sort === 'asc' ? -1 : 1;
            }

            return 0;
        });
    }

    changeFilterCarrierF(data: any, config: any): any {
        let filteredData: Array<any> = data;

        this.columnsCarrierF.forEach((column: any) => {
            if (column.filtering) {
                filteredData = filteredData.filter((item: any) => {
                    return item[column.name].match(column.filtering.filterString);
                });
            }
        });

        if (!config.filtering) {
            return filteredData;
        }

        if (config.filtering.columnName) {
            return filteredData.filter((item: any) => item[config.filtering.columnName].match(this.configCarrierF.filtering.filterString));
        }

        let tempArray: Array<any> = [];

        filteredData.forEach((item: any) => {
            let flag = false;

            this.columnsCarrierF.forEach((column: any) => {
                if (item[column.name] &&
                    item[column.name].toString().toLowerCase().match(this.configCarrierF.filtering.filterString.toLowerCase())) {
                    flag = true;
                }
            });

            if (flag) {
                tempArray.push(item);
            }
        });

        filteredData = tempArray;

        return filteredData;
    }

    onChangeTableCarrierF(config: any, page: any = {page: this.pageCarrierF, itemsPerPage: this.itemsPerPageCarrierF}): any {
        if (config.filtering) {
            Object.assign(this.configCarrierF.filtering, config.filtering);
        }

        if (config.sorting) {
            Object.assign(this.configCarrierF.sorting, config.sorting);
        }

        let filteredData = this.changeFilterCarrierF(this.dataCarrierF, this.configCarrierF);
        let sortedData = this.changeSortCarrierF(filteredData, this.configCarrierF);

        this.rowsCarrierF = page && config.paging ? this.changePageCarrierF(page, sortedData) : sortedData;
        this.lengthCarrierF = sortedData.length;
    }

    changePageOver(page: any, data: Array<any> = this.dataOver): Array<any> {
        let start = (page.page - 1) * page.itemsPerPage;
        let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;

        return data.slice(start, end);
    }

    onChangeTableOver(config: any, page: any = {page: this.pageOver, itemsPerPage: this.itemsPerPageOver}): any {
        this.rowsOver = page && config.paging ? this.changePageOver(page, this.dataOver) : this.dataOver;
        this.lengthOver = this.dataOver.length;
    }

    changePageLoan(page: any, data: Array<any> = this.dataLoan): Array<any> {
        let start = (page.page - 1) * page.itemsPerPage;
        let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;

        return data.slice(start, end);
    }

    onChangeTableLoan(config: any, page: any = {page: this.pageLoan, itemsPerPage: this.itemsPerPageLoan}): any {
        this.rowsLoan = page && config.paging ? this.changePageLoan(page, this.dataLoan) : this.dataLoan;
        this.lengthLoan = this.dataLoan.length;
    }

    changePageEstimate(page: any, data: Array<any> = this.dataEstimate): Array<any> {
        let start = (page.page - 1) * page.itemsPerPage;
        let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;

        return data.slice(start, end);
    }

    onChangeTableEstimate(config: any, page: any = {page: this.pageEstimate, itemsPerPage: this.itemsPerPageEstimate}): any {
        this.rowsEstimate = page && config.paging ? this.changePageEstimate(page, this.dataEstimate) : this.dataEstimate;
        this.lengthEstimate = this.dataEstimate.length;
    }

}
